module.exports=[
  {
    "date": "7/1/2018",
    "min": 48,
    "avg": 89,
    "max": 149
  },
  {
    "date": "7/2/2018",
    "min": 18,
    "avg": 45,
    "max": 84
  },
  {
    "date": "7/3/2018",
    "min": 29,
    "avg": 51,
    "max": 75
  },
  {
    "date": "7/4/2018",
    "min": 28,
    "avg": 59,
    "max": 97
  },
  {
    "date": "7/5/2018",
    "min": 15,
    "avg": 45,
    "max": 80
  },
  {
    "date": "7/6/2018",
    "min": 18,
    "avg": 33,
    "max": 56
  },
  {
    "date": "7/7/2018",
    "min": 9,
    "avg": 23,
    "max": 40
  },
  {
    "date": "7/8/2018",
    "min": 20,
    "avg": 31,
    "max": 41
  },
  {
    "date": "7/9/2018"
  },
  {
    "date": "7/10/2018"
  },
  {
    "date": "7/11/2018"
  },
  {
    "date": "7/12/2018"
  },
  {
    "date": "7/13/2018"
  },
  {
    "date": "7/14/2018"
  },
  {
    "date": "7/15/2018"
  },
  {
    "date": "7/16/2018"
  },
  {
    "date": "7/17/2018"
  },
  {
    "date": "7/18/2018"
  },
  {
    "date": "7/19/2018"
  },
  {
    "date": "7/20/2018",
    "min": 25,
    "avg": 28,
    "max": 36
  },
  {
    "date": "7/21/2018",
    "min": 11,
    "avg": 28,
    "max": 54
  },
  {
    "date": "7/22/2018",
    "min": 45,
    "avg": 62,
    "max": 73
  },
  {
    "date": "7/25/2018",
    "min": 19,
    "avg": 38,
    "max": 85
  },
  {
    "date": "7/26/2018",
    "min": 10,
    "avg": 32,
    "max": 74
  },
  {
    "date": "7/27/2018",
    "min": 12,
    "avg": 27,
    "max": 45
  },
  {
    "date": "7/28/2018",
    "min": 13,
    "avg": 27,
    "max": 40
  },
  {
    "date": "7/29/2018",
    "min": 6,
    "avg": 26,
    "max": 79
  },
  {
    "date": "7/30/2018",
    "min": 40,
    "avg": 58,
    "max": 82
  },
  {
    "date": "7/31/2018",
    "min": 34,
    "avg": 53,
    "max": 79
  },
  {
    "date": "8/1/2018",
    "min": 6,
    "avg": 22,
    "max": 44
  },
  {
    "date": "8/2/2018",
    "min": 15,
    "avg": 31,
    "max": 65
  },
  {
    "date": "8/3/2018",
    "min": 8,
    "avg": 24,
    "max": 47
  },
  {
    "date": "8/4/2018",
    "min": 25,
    "avg": 51,
    "max": 77
  },
  {
    "date": "8/5/2018",
    "min": 9,
    "avg": 22,
    "max": 75
  },
  {
    "date": "8/6/2018",
    "min": 15,
    "avg": 28,
    "max": 58
  },
  {
    "date": "8/7/2018",
    "min": 21,
    "avg": 41,
    "max": 68
  },
  {
    "date": "8/8/2018",
    "min": 20,
    "avg": 31,
    "max": 55
  },
  {
    "date": "8/9/2018",
    "min": 12,
    "avg": 36,
    "max": 55
  },
  {
    "date": "8/10/2018",
    "min": 10,
    "avg": 21,
    "max": 32
  },
  {
    "date": "8/11/2018",
    "min": 13,
    "avg": 26,
    "max": 44
  },
  {
    "date": "8/12/2018",
    "min": 8,
    "avg": 18,
    "max": 48
  },
  {
    "date": "8/13/2018",
    "min": 11,
    "avg": 24,
    "max": 55
  },
  {
    "date": "8/14/2018",
    "min": 6,
    "avg": 29,
    "max": 59
  },
  {
    "date": "8/15/2018",
    "min": 9,
    "avg": 22,
    "max": 37
  },
  {
    "date": "8/16/2018",
    "min": 5,
    "avg": 19,
    "max": 35
  },
  {
    "date": "8/17/2018",
    "min": 12,
    "avg": 49,
    "max": 153
  },
  {
    "date": "8/18/2018",
    "min": 10,
    "avg": 37,
    "max": 78
  },
  {
    "date": "8/19/2018",
    "min": 13,
    "avg": 29,
    "max": 81
  },
  {
    "date": "8/20/2018",
    "min": 54,
    "avg": 87,
    "max": 125
  },
  {
    "date": "8/21/2018",
    "min": 60,
    "avg": 84,
    "max": 110
  },
  {
    "date": "8/22/2018",
    "min": 6,
    "avg": 64,
    "max": 121
  },
  {
    "date": "8/23/2018",
    "min": 7,
    "avg": 14,
    "max": 22
  },
  {
    "date": "8/24/2018",
    "min": 10,
    "avg": 16,
    "max": 22
  },
  {
    "date": "8/25/2018",
    "min": 6,
    "avg": 14,
    "max": 24
  },
  {
    "date": "8/26/2018",
    "min": 8,
    "avg": 15,
    "max": 23
  },
  {
    "date": "8/27/2018",
    "min": 6,
    "avg": 26,
    "max": 89
  },
  {
    "date": "8/28/2018",
    "min": 53,
    "avg": 69,
    "max": 95
  },
  {
    "date": "8/29/2018",
    "min": 31,
    "avg": 56,
    "max": 103
  },
  {
    "date": "8/30/2018",
    "min": 16,
    "avg": 37,
    "max": 62
  },
  {
    "date": "8/31/2018",
    "min": 26,
    "avg": 49,
    "max": 112
  },
  {
    "date": "9/1/2018",
    "min": 52,
    "avg": 76,
    "max": 110
  },
  {
    "date": "9/2/2018",
    "min": 28,
    "avg": 48,
    "max": 79
  },
  {
    "date": "9/3/2018",
    "min": 31,
    "avg": 63,
    "max": 102
  },
  {
    "date": "9/4/2018",
    "min": 42,
    "avg": 63,
    "max": 92
  },
  {
    "date": "9/5/2018",
    "min": 23,
    "avg": 36,
    "max": 59
  },
  {
    "date": "9/6/2018",
    "min": 8,
    "avg": 33,
    "max": 155
  },
  {
    "date": "9/7/2018",
    "min": 18,
    "avg": 74,
    "max": 176
  },
  {
    "date": "9/8/2018",
    "min": 24,
    "avg": 61,
    "max": 124
  },
  {
    "date": "9/9/2018",
    "min": 22,
    "avg": 64,
    "max": 132
  },
  {
    "date": "9/10/2018",
    "min": 52,
    "avg": 80,
    "max": 122
  },
  {
    "date": "9/11/2018",
    "min": 10,
    "avg": 29,
    "max": 75
  },
  {
    "date": "9/12/2018",
    "min": 24,
    "avg": 66,
    "max": 160
  },
  {
    "date": "9/13/2018",
    "min": 19,
    "avg": 55,
    "max": 143
  },
  {
    "date": "9/14/2018",
    "min": 14,
    "avg": 38,
    "max": 158
  },
  {
    "date": "9/15/2018",
    "min": 19,
    "avg": 68,
    "max": 170
  },
  {
    "date": "9/16/2018",
    "min": 20,
    "avg": 78,
    "max": 159
  },
  {
    "date": "9/17/2018",
    "min": 17,
    "avg": 61,
    "max": 133
  },
  {
    "date": "9/18/2018",
    "min": 28,
    "avg": 79,
    "max": 155
  },
  {
    "date": "9/19/2018",
    "min": 42,
    "avg": 81,
    "max": 152
  },
  {
    "date": "9/20/2018",
    "min": 9,
    "avg": 29,
    "max": 74
  },
  {
    "date": "9/21/2018",
    "min": 13,
    "avg": 45,
    "max": 191
  },
  {
    "date": "9/22/2018",
    "min": 33,
    "avg": 109,
    "max": 266
  },
  {
    "date": "9/23/2018",
    "min": 35,
    "avg": 89,
    "max": 154
  },
  {
    "date": "9/24/2018",
    "min": 18,
    "avg": 84,
    "max": 152
  },
  {
    "date": "9/25/2018",
    "min": 28,
    "avg": 74,
    "max": 144
  },
  {
    "date": "9/26/2018",
    "min": 44,
    "avg": 72,
    "max": 137
  },
  {
    "date": "9/27/2018",
    "min": 17,
    "avg": 36,
    "max": 59
  },
  {
    "date": "9/28/2018",
    "min": 27,
    "avg": 44,
    "max": 59
  },
  {
    "date": "9/29/2018",
    "min": 6,
    "avg": 26,
    "max": 66
  },
  {
    "date": "9/30/2018",
    "min": 40,
    "avg": 76,
    "max": 160
  },
  {
    "date": "10/1/2018",
    "min": 29,
    "avg": 124,
    "max": 165
  },
  {
    "date": "10/2/2018",
    "min": 43,
    "avg": 113,
    "max": 171
  },
  {
    "date": "10/3/2018",
    "min": 26,
    "avg": 111,
    "max": 183
  },
  {
    "date": "10/4/2018",
    "min": 27,
    "avg": 72,
    "max": 160
  },
  {
    "date": "10/5/2018",
    "min": 12,
    "avg": 32,
    "max": 52
  },
  {
    "date": "10/6/2018",
    "min": 18,
    "avg": 36,
    "max": 63
  },
  {
    "date": "10/7/2018",
    "min": 19,
    "avg": 45,
    "max": 75
  },
  {
    "date": "10/8/2018",
    "min": 27,
    "avg": 56,
    "max": 110
  },
  {
    "date": "10/9/2018",
    "min": 35,
    "avg": 94,
    "max": 165
  },
  {
    "date": "10/10/2018",
    "min": 40,
    "avg": 159,
    "max": 238
  },
  {
    "date": "10/11/2018",
    "min": 40,
    "avg": 122,
    "max": 178
  },
  {
    "date": "10/12/2018",
    "min": 51,
    "avg": 115,
    "max": 183
  },
  {
    "date": "10/13/2018",
    "min": 42,
    "avg": 115,
    "max": 163
  },
  {
    "date": "10/14/2018",
    "min": 53,
    "avg": 118,
    "max": 168
  },
  {
    "date": "10/15/2018",
    "min": 55,
    "avg": 125,
    "max": 171
  },
  {
    "date": "10/16/2018",
    "min": 58,
    "avg": 124,
    "max": 171
  },
  {
    "date": "10/17/2018",
    "min": 59,
    "avg": 133,
    "max": 180
  },
  {
    "date": "10/18/2018",
    "min": 67,
    "avg": 132,
    "max": 180
  },
  {
    "date": "10/19/2018",
    "min": 34,
    "avg": 91,
    "max": 173
  },
  {
    "date": "10/20/2018",
    "min": 58,
    "avg": 120,
    "max": 190
  },
  {
    "date": "10/21/2018",
    "min": 57,
    "avg": 125,
    "max": 182
  },
  {
    "date": "10/22/2018",
    "min": 28,
    "avg": 58,
    "max": 159
  },
  {
    "date": "10/23/2018",
    "min": 60,
    "avg": 125,
    "max": 182
  },
  {
    "date": "10/24/2018",
    "min": 27,
    "avg": 88,
    "max": 175
  },
  {
    "date": "10/25/2018",
    "min": 19,
    "avg": 43,
    "max": 64
  },
  {
    "date": "10/26/2018",
    "min": 53,
    "avg": 99,
    "max": 183
  },
  {
    "date": "10/27/2018",
    "min": 27,
    "avg": 89,
    "max": 188
  },
  {
    "date": "10/28/2018",
    "min": 17,
    "avg": 55,
    "max": 204
  },
  {
    "date": "10/29/2018",
    "min": 39,
    "avg": 141,
    "max": 187
  },
  {
    "date": "10/30/2018",
    "min": 92,
    "avg": 146,
    "max": 248
  },
  {
    "date": "10/31/2018",
    "min": 28,
    "avg": 129,
    "max": 197
  },
  {
    "date": "11/1/2018",
    "min": 39,
    "avg": 95,
    "max": 202
  },
  {
    "date": "11/2/2018",
    "min": 28,
    "avg": 85,
    "max": 197
  },
  {
    "date": "11/3/2018",
    "min": 18,
    "avg": 59,
    "max": 168
  },
  {
    "date": "11/4/2018",
    "min": 39,
    "avg": 138,
    "max": 192
  },
  {
    "date": "11/5/2018",
    "min": 34,
    "avg": 125,
    "max": 215
  },
  {
    "date": "11/6/2018",
    "min": 60,
    "avg": 160,
    "max": 249
  },
  {
    "date": "11/7/2018",
    "min": 80,
    "avg": 200,
    "max": 388
  },
  {
    "date": "11/8/2018",
    "min": 60,
    "avg": 72,
    "max": 83
  },
  {
    "date": "11/9/2018"
  },
  {
    "date": "11/10/2018"
  },
  {
    "date": "11/11/2018"
  },
  {
    "date": "11/12/2018"
  },
  {
    "date": "11/13/2018"
  },
  {
    "date": "11/14/2018",
    "min": 48,
    "avg": 109,
    "max": 177
  },
  {
    "date": "11/15/2018",
    "min": 41,
    "avg": 135,
    "max": 222
  },
  {
    "date": "11/16/2018",
    "min": 63,
    "avg": 168,
    "max": 337
  },
  {
    "date": "11/17/2018",
    "min": 59,
    "avg": 148,
    "max": 210
  },
  {
    "date": "11/18/2018",
    "min": 45,
    "avg": 142,
    "max": 198
  },
  {
    "date": "11/19/2018",
    "min": 123,
    "avg": 178,
    "max": 303
  },
  {
    "date": "11/20/2018",
    "min": 64,
    "avg": 173,
    "max": 302
  },
  {
    "date": "11/21/2018",
    "min": 83,
    "avg": 197,
    "max": 422
  },
  {
    "date": "11/22/2018",
    "min": 87,
    "avg": 198,
    "max": 405
  },
  {
    "date": "11/23/2018",
    "min": 132,
    "avg": 223,
    "max": 406
  },
  {
    "date": "11/24/2018",
    "min": 152,
    "avg": 250,
    "max": 432
  },
  {
    "date": "11/25/2018",
    "min": 128,
    "avg": 261,
    "max": 427
  },
  {
    "date": "11/26/2018",
    "min": 40,
    "avg": 101,
    "max": 192
  },
  {
    "date": "11/27/2018",
    "min": 134,
    "avg": 187,
    "max": 249
  },
  {
    "date": "11/28/2018",
    "min": 188,
    "avg": 301,
    "max": 484
  },
  {
    "date": "11/29/2018",
    "min": 166,
    "avg": 327,
    "max": 562
  },
  {
    "date": "11/30/2018",
    "min": 169,
    "avg": 316,
    "max": 629
  },
  {
    "date": "12/1/2018",
    "min": 107,
    "avg": 414,
    "max": 758
  },
  {
    "date": "12/2/2018",
    "min": 54,
    "avg": 116,
    "max": 351
  },
  {
    "date": "12/3/2018",
    "min": 96,
    "avg": 187,
    "max": 335
  },
  {
    "date": "12/4/2018",
    "min": 159,
    "avg": 213,
    "max": 409
  },
  {
    "date": "12/5/2018",
    "min": 153,
    "avg": 244,
    "max": 445
  },
  {
    "date": "12/6/2018",
    "min": 66,
    "avg": 128,
    "max": 238
  },
  {
    "date": "12/7/2018",
    "min": 78,
    "avg": 291,
    "max": 603
  },
  {
    "date": "12/8/2018",
    "min": 164,
    "avg": 301,
    "max": 490
  },
  {
    "date": "12/9/2018",
    "min": 117,
    "avg": 320,
    "max": 553
  },
  {
    "date": "12/10/2018",
    "min": 92,
    "avg": 176,
    "max": 372
  },
  {
    "date": "12/11/2018",
    "min": 178,
    "avg": 331,
    "max": 584
  },
  {
    "date": "12/12/2018",
    "min": 89,
    "avg": 311,
    "max": 469
  },
  {
    "date": "12/13/2018",
    "min": 217,
    "avg": 240,
    "max": 267
  },
  {
    "date": "12/14/2018",
    "min": 162,
    "avg": 238,
    "max": 419
  },
  {
    "date": "12/15/2018",
    "min": 168,
    "avg": 292,
    "max": 550
  },
  {
    "date": "12/16/2018",
    "min": 146,
    "avg": 312,
    "max": 572
  },
  {
    "date": "12/17/2018",
    "min": 112,
    "avg": 322,
    "max": 663
  },
  {
    "date": "12/18/2018",
    "min": 168,
    "avg": 366,
    "max": 612
  },
  {
    "date": "12/19/2018",
    "min": 169,
    "avg": 410,
    "max": 646
  },
  {
    "date": "12/20/2018",
    "min": 131,
    "avg": 269,
    "max": 488
  },
  {
    "date": "12/21/2018",
    "min": 122,
    "avg": 261,
    "max": 569
  },
  {
    "date": "12/22/2018",
    "min": 56,
    "avg": 120,
    "max": 297
  },
  {
    "date": "12/23/2018",
    "min": 175,
    "avg": 258,
    "max": 431
  },
  {
    "date": "12/24/2018",
    "min": 91,
    "avg": 339,
    "max": 663
  },
  {
    "date": "12/25/2018",
    "min": 74,
    "avg": 188,
    "max": 473
  },
  {
    "date": "12/26/2018",
    "min": 107,
    "avg": 250,
    "max": 455
  },
  {
    "date": "12/27/2018",
    "min": 76,
    "avg": 208,
    "max": 535
  },
  {
    "date": "12/28/2018",
    "min": 91,
    "avg": 199,
    "max": 445
  },
  {
    "date": "12/29/2018",
    "min": 136,
    "avg": 275,
    "max": 453
  },
  {
    "date": "12/30/2018",
    "min": 293,
    "avg": 395,
    "max": 478
  },
  {
    "date": "12/31/2018",
    "min": 166,
    "avg": 331,
    "max": 697
  },
  {
    "date": "1/1/2019",
    "min": 107,
    "avg": 277,
    "max": 434
  },
  {
    "date": "1/2/2019",
    "min": 114,
    "avg": 344,
    "max": 602
  },
  {
    "date": "1/3/2019",
    "min": 92,
    "avg": 232,
    "max": 380
  },
  {
    "date": "1/4/2019",
    "min": 156,
    "avg": 269,
    "max": 530
  },
  {
    "date": "1/5/2019",
    "min": 149,
    "avg": 358,
    "max": 626
  },
  {
    "date": "1/6/2019",
    "min": 140,
    "avg": 328,
    "max": 577
  },
  {
    "date": "1/7/2019",
    "min": 111,
    "avg": 235,
    "max": 432
  },
  {
    "date": "1/8/2019",
    "min": 158,
    "avg": 330,
    "max": 576
  },
  {
    "date": "1/9/2019",
    "min": 164,
    "avg": 478,
    "max": 731
  },
  {
    "date": "1/10/2019",
    "min": 157,
    "avg": 447,
    "max": 650
  },
  {
    "date": "1/11/2019",
    "min": 124,
    "avg": 375,
    "max": 634
  },
  {
    "date": "1/12/2019",
    "min": 78,
    "avg": 324,
    "max": 730
  },
  {
    "date": "1/13/2019",
    "min": 142,
    "avg": 332,
    "max": 491
  },
  {
    "date": "1/14/2019",
    "min": 64,
    "avg": 180,
    "max": 514
  },
  {
    "date": "1/15/2019",
    "min": 183,
    "avg": 302,
    "max": 555
  },
  {
    "date": "1/16/2019",
    "min": 161,
    "avg": 369,
    "max": 596
  },
  {
    "date": "1/17/2019",
    "min": 95,
    "avg": 323,
    "max": 493
  },
  {
    "date": "1/18/2019",
    "min": 167,
    "avg": 239,
    "max": 484
  },
  {
    "date": "1/19/2019",
    "min": 182,
    "avg": 250,
    "max": 374
  },
  {
    "date": "1/20/2019"
  },
  {
    "date": "1/21/2019"
  },
  {
    "date": "1/22/2019",
    "min": 157,
    "avg": 279,
    "max": 596
  },
  {
    "date": "1/23/2019",
    "min": 74,
    "avg": 195,
    "max": 471
  },
  {
    "date": "1/24/2019",
    "min": 79,
    "avg": 187,
    "max": 266
  },
  {
    "date": "1/25/2019",
    "min": 76,
    "avg": 256,
    "max": 544
  },
  {
    "date": "1/26/2019",
    "min": 47,
    "avg": 88,
    "max": 197
  },
  {
    "date": "1/27/2019",
    "min": 44,
    "avg": 86,
    "max": 198
  },
  {
    "date": "1/28/2019",
    "min": 119,
    "avg": 259,
    "max": 529
  },
  {
    "date": "1/29/2019",
    "min": 52,
    "avg": 119,
    "max": 325
  },
  {
    "date": "1/30/2019",
    "min": 52,
    "avg": 158,
    "max": 292
  },
  {
    "date": "1/31/2019",
    "min": 79,
    "avg": 186,
    "max": 340
  },
  {
    "date": "2/1/2019",
    "min": 138,
    "avg": 281,
    "max": 482
  },
  {
    "date": "2/2/2019",
    "min": 45,
    "avg": 91,
    "max": 247
  },
  {
    "date": "2/3/2019",
    "min": 62,
    "avg": 177,
    "max": 317
  },
  {
    "date": "2/4/2019",
    "min": 68,
    "avg": 203,
    "max": 433
  },
  {
    "date": "2/5/2019",
    "min": 42,
    "avg": 138,
    "max": 251
  },
  {
    "date": "2/6/2019",
    "min": 55,
    "avg": 134,
    "max": 243
  },
  {
    "date": "2/7/2019",
    "min": 84,
    "avg": 187,
    "max": 304
  },
  {
    "date": "2/8/2019",
    "min": 76,
    "avg": 158,
    "max": 247
  },
  {
    "date": "2/9/2019",
    "min": 57,
    "avg": 152,
    "max": 297
  },
  {
    "date": "2/10/2019",
    "min": 58,
    "avg": 166,
    "max": 324
  },
  {
    "date": "2/11/2019",
    "min": 92,
    "avg": 203,
    "max": 434
  },
  {
    "date": "2/12/2019",
    "min": 69,
    "avg": 197,
    "max": 442
  },
  {
    "date": "2/13/2019",
    "min": 73,
    "avg": 217,
    "max": 465
  },
  {
    "date": "2/14/2019",
    "min": 71,
    "avg": 177,
    "max": 316
  },
  {
    "date": "2/15/2019",
    "min": 58,
    "avg": 179,
    "max": 430
  },
  {
    "date": "2/16/2019",
    "min": 71,
    "avg": 199,
    "max": 448
  },
  {
    "date": "2/17/2019",
    "min": 71,
    "avg": 215,
    "max": 439
  },
  {
    "date": "2/18/2019",
    "min": 71,
    "avg": 229,
    "max": 460
  },
  {
    "date": "2/19/2019",
    "min": 107,
    "avg": 241,
    "max": 517
  },
  {
    "date": "2/20/2019",
    "min": 106,
    "avg": 246,
    "max": 473
  },
  {
    "date": "2/21/2019",
    "min": 149,
    "avg": 232,
    "max": 514
  },
  {
    "date": "2/22/2019",
    "min": 72,
    "avg": 195,
    "max": 397
  },
  {
    "date": "2/23/2019",
    "min": 71,
    "avg": 181,
    "max": 264
  },
  {
    "date": "2/24/2019",
    "min": 61,
    "avg": 163,
    "max": 299
  },
  {
    "date": "2/25/2019",
    "min": 49,
    "avg": 175,
    "max": 392
  },
  {
    "date": "2/26/2019",
    "min": 63,
    "avg": 163,
    "max": 297
  },
  {
    "date": "2/27/2019",
    "min": 79,
    "avg": 164,
    "max": 303
  },
  {
    "date": "2/28/2019",
    "min": 72,
    "avg": 163,
    "max": 356
  },
  {
    "date": "3/1/2019",
    "min": 73,
    "avg": 215,
    "max": 440
  },
  {
    "date": "3/2/2019",
    "min": 57,
    "avg": 144,
    "max": 246
  },
  {
    "date": "3/3/2019",
    "min": 64,
    "avg": 144,
    "max": 195
  },
  {
    "date": "3/4/2019",
    "min": 50,
    "avg": 144,
    "max": 345
  },
  {
    "date": "3/5/2019",
    "min": 41,
    "avg": 162,
    "max": 259
  },
  {
    "date": "3/6/2019",
    "min": 27,
    "avg": 94,
    "max": 202
  },
  {
    "date": "3/7/2019",
    "min": 36,
    "avg": 135,
    "max": 196
  },
  {
    "date": "3/8/2019",
    "min": 51,
    "avg": 95,
    "max": 191
  },
  {
    "date": "3/9/2019",
    "min": 53,
    "avg": 101,
    "max": 174
  },
  {
    "date": "3/10/2019",
    "min": 30,
    "avg": 123,
    "max": 185
  },
  {
    "date": "3/11/2019",
    "min": 18,
    "avg": 60,
    "max": 188
  },
  {
    "date": "3/12/2019",
    "min": 42,
    "avg": 130,
    "max": 211
  },
  {
    "date": "3/13/2019",
    "min": 36,
    "avg": 132,
    "max": 204
  },
  {
    "date": "3/14/2019",
    "min": 20,
    "avg": 137,
    "max": 245
  },
  {
    "date": "3/15/2019",
    "min": 53,
    "avg": 145,
    "max": 238
  },
  {
    "date": "3/16/2019",
    "min": 43,
    "avg": 145,
    "max": 220
  },
  {
    "date": "3/17/2019",
    "min": 24,
    "avg": 140,
    "max": 222
  },
  {
    "date": "3/18/2019",
    "min": 48,
    "avg": 116,
    "max": 175
  },
  {
    "date": "3/19/2019",
    "min": 12,
    "avg": 35,
    "max": 54
  },
  {
    "date": "3/20/2019",
    "min": 16,
    "avg": 45,
    "max": 106
  },
  {
    "date": "3/21/2019",
    "min": 43,
    "avg": 111,
    "max": 174
  },
  {
    "date": "3/22/2019",
    "min": 30,
    "avg": 87,
    "max": 197
  },
  {
    "date": "3/23/2019",
    "min": 21,
    "avg": 123,
    "max": 210
  },
  {
    "date": "3/24/2019",
    "min": 26,
    "avg": 123,
    "max": 218
  },
  {
    "date": "3/25/2019",
    "min": 30,
    "avg": 128,
    "max": 186
  },
  {
    "date": "3/26/2019",
    "min": 54,
    "avg": 117,
    "max": 200
  },
  {
    "date": "3/27/2019",
    "min": 15,
    "avg": 55,
    "max": 162
  },
  {
    "date": "3/28/2019",
    "min": 58,
    "avg": 105,
    "max": 166
  },
  {
    "date": "3/29/2019",
    "min": 34,
    "avg": 66,
    "max": 174
  },
  {
    "date": "3/30/2019",
    "min": 25,
    "avg": 98,
    "max": 181
  },
  {
    "date": "3/31/2019",
    "min": 29,
    "avg": 115,
    "max": 173
  },
  {
    "date": "4/1/2019",
    "min": 22,
    "avg": 115,
    "max": 181
  },
  {
    "date": "4/2/2019",
    "min": 35,
    "avg": 113,
    "max": 180
  },
  {
    "date": "4/3/2019",
    "min": 59,
    "avg": 104,
    "max": 165
  },
  {
    "date": "4/4/2019",
    "min": 20,
    "avg": 41,
    "max": 92
  },
  {
    "date": "4/5/2019",
    "min": 23,
    "avg": 59,
    "max": 122
  },
  {
    "date": "4/6/2019",
    "min": 33,
    "avg": 76,
    "max": 154
  },
  {
    "date": "4/7/2019",
    "min": 52,
    "avg": 124,
    "max": 179
  },
  {
    "date": "4/8/2019",
    "min": 17,
    "avg": 76,
    "max": 166
  },
  {
    "date": "4/9/2019",
    "min": 26,
    "avg": 79,
    "max": 159
  },
  {
    "date": "4/10/2019",
    "min": 51,
    "avg": 103,
    "max": 181
  },
  {
    "date": "4/11/2019",
    "min": 35,
    "avg": 107,
    "max": 164
  },
  {
    "date": "4/12/2019",
    "min": 30,
    "avg": 76,
    "max": 165
  },
  {
    "date": "4/13/2019",
    "min": 35,
    "avg": 85,
    "max": 178
  },
  {
    "date": "4/14/2019",
    "min": 32,
    "avg": 99,
    "max": 174
  },
  {
    "date": "4/15/2019",
    "min": 34,
    "avg": 100,
    "max": 163
  },
  {
    "date": "4/16/2019",
    "min": 25,
    "avg": 72,
    "max": 141
  },
  {
    "date": "4/17/2019",
    "min": 18,
    "avg": 32,
    "max": 75
  },
  {
    "date": "4/18/2019",
    "min": 9,
    "avg": 59,
    "max": 122
  },
  {
    "date": "4/19/2019",
    "min": 26,
    "avg": 73,
    "max": 160
  },
  {
    "date": "4/20/2019",
    "min": 40,
    "avg": 53,
    "max": 74
  },
  {
    "date": "4/21/2019",
    "min": 49,
    "avg": 90,
    "max": 146
  },
  {
    "date": "4/22/2019",
    "min": 25,
    "avg": 60,
    "max": 107
  },
  {
    "date": "4/23/2019",
    "min": 24,
    "avg": 45,
    "max": 78
  },
  {
    "date": "4/24/2019",
    "min": 23,
    "avg": 46,
    "max": 99
  },
  {
    "date": "4/25/2019",
    "min": 35,
    "avg": 48,
    "max": 63
  },
  {
    "date": "4/26/2019",
    "min": 52,
    "avg": 98,
    "max": 178
  },
  {
    "date": "4/27/2019",
    "min": 16,
    "avg": 79,
    "max": 170
  },
  {
    "date": "4/28/2019",
    "min": 29,
    "avg": 75,
    "max": 154
  },
  {
    "date": "4/29/2019",
    "min": 15,
    "avg": 64,
    "max": 163
  },
  {
    "date": "4/30/2019",
    "min": 18,
    "avg": 79,
    "max": 154
  },
  {
    "date": "5/1/2019",
    "min": 27,
    "avg": 77,
    "max": 145
  },
  {
    "date": "5/2/2019",
    "min": 55,
    "avg": 85,
    "max": 125
  },
  {
    "date": "5/3/2019",
    "min": 52,
    "avg": 79,
    "max": 112
  },
  {
    "date": "5/4/2019",
    "min": 15,
    "avg": 31,
    "max": 66
  },
  {
    "date": "5/5/2019",
    "min": 22,
    "avg": 63,
    "max": 122
  },
  {
    "date": "5/6/2019",
    "min": 13,
    "avg": 61,
    "max": 140
  },
  {
    "date": "5/7/2019",
    "min": 26,
    "avg": 67,
    "max": 151
  },
  {
    "date": "5/8/2019",
    "min": 36,
    "avg": 82,
    "max": 157
  },
  {
    "date": "5/9/2019",
    "min": 32,
    "avg": 70,
    "max": 153
  },
  {
    "date": "5/10/2019",
    "min": 18,
    "avg": 48,
    "max": 89
  },
  {
    "date": "5/11/2019",
    "min": 18,
    "avg": 32,
    "max": 55
  },
  {
    "date": "5/12/2019"
  },
  {
    "date": "5/13/2019",
    "min": 17,
    "avg": 38,
    "max": 72
  },
  {
    "date": "5/14/2019",
    "min": 38,
    "avg": 54,
    "max": 95
  },
  {
    "date": "5/15/2019",
    "min": 6,
    "avg": 30,
    "max": 117
  },
  {
    "date": "5/16/2019",
    "min": 10,
    "avg": 47,
    "max": 132
  },
  {
    "date": "5/17/2019",
    "min": 13,
    "avg": 33,
    "max": 62
  },
  {
    "date": "5/18/2019",
    "min": 27,
    "avg": 67,
    "max": 159
  },
  {
    "date": "5/19/2019",
    "min": 31,
    "avg": 52,
    "max": 144
  },
  {
    "date": "5/20/2019",
    "min": 15,
    "avg": 70,
    "max": 160
  },
  {
    "date": "5/21/2019",
    "min": 6,
    "avg": 59,
    "max": 152
  },
  {
    "date": "5/22/2019",
    "min": 19,
    "avg": 61,
    "max": 93
  },
  {
    "date": "5/23/2019",
    "min": 43,
    "avg": 64,
    "max": 110
  },
  {
    "date": "5/24/2019",
    "min": 15,
    "avg": 45,
    "max": 75
  },
  {
    "date": "5/25/2019",
    "min": 20,
    "avg": 33,
    "max": 53
  },
  {
    "date": "5/26/2019",
    "min": 9,
    "avg": 39,
    "max": 100
  },
  {
    "date": "5/27/2019",
    "min": 33,
    "avg": 65,
    "max": 114
  },
  {
    "date": "5/28/2019",
    "min": 28,
    "avg": 57,
    "max": 110
  },
  {
    "date": "5/29/2019",
    "min": 14,
    "avg": 32,
    "max": 58
  },
  {
    "date": "5/30/2019",
    "min": 8,
    "avg": 42,
    "max": 77
  },
  {
    "date": "5/31/2019",
    "min": 8,
    "avg": 44,
    "max": 93
  },
  {
    "date": "6/1/2019",
    "min": 56,
    "avg": 96,
    "max": 158
  },
  {
    "date": "6/2/2019",
    "min": 25,
    "avg": 111,
    "max": 210
  },
  {
    "date": "6/3/2019",
    "min": 67,
    "avg": 142,
    "max": 176
  },
  {
    "date": "6/4/2019",
    "min": 24,
    "avg": 105,
    "max": 297
  },
  {
    "date": "6/5/2019",
    "min": 9,
    "avg": 42,
    "max": 107
  },
  {
    "date": "6/6/2019",
    "min": 35,
    "avg": 116,
    "max": 197
  },
  {
    "date": "6/7/2019",
    "min": 20,
    "avg": 48,
    "max": 90
  },
  {
    "date": "6/8/2019",
    "min": 13,
    "avg": 56,
    "max": 144
  },
  {
    "date": "6/9/2019",
    "min": 20,
    "avg": 76,
    "max": 166
  },
  {
    "date": "6/10/2019",
    "min": 27,
    "avg": 74,
    "max": 133
  },
  {
    "date": "6/11/2019",
    "min": 45,
    "avg": 119,
    "max": 275
  },
  {
    "date": "6/12/2019",
    "min": 25,
    "avg": 82,
    "max": 174
  },
  {
    "date": "6/13/2019",
    "min": 9,
    "avg": 44,
    "max": 86
  },
  {
    "date": "6/14/2019",
    "min": 13,
    "avg": 75,
    "max": 159
  },
  {
    "date": "6/15/2019",
    "min": 10,
    "avg": 52,
    "max": 101
  },
  {
    "date": "6/16/2019",
    "min": 23,
    "avg": 55,
    "max": 116
  },
  {
    "date": "6/17/2019",
    "min": 25,
    "avg": 40,
    "max": 68
  },
  {
    "date": "6/18/2019",
    "min": 17,
    "avg": 45,
    "max": 78
  },
  {
    "date": "6/19/2019",
    "min": 26,
    "avg": 55,
    "max": 81
  },
  {
    "date": "6/20/2019",
    "min": 11,
    "avg": 61,
    "max": 125
  },
  {
    "date": "6/21/2019",
    "min": 18,
    "avg": 67,
    "max": 117
  },
  {
    "date": "6/22/2019",
    "min": 38,
    "avg": 81,
    "max": 159
  },
  {
    "date": "6/23/2019",
    "min": 54,
    "avg": 67,
    "max": 119
  },
  {
    "date": "6/24/2019",
    "min": 60,
    "avg": 119,
    "max": 170
  },
  {
    "date": "6/25/2019",
    "min": 35,
    "avg": 59,
    "max": 79
  },
  {
    "date": "6/26/2019",
    "min": 10,
    "avg": 33,
    "max": 89
  },
  {
    "date": "6/27/2019",
    "min": 10,
    "avg": 27,
    "max": 160
  },
  {
    "date": "6/28/2019",
    "min": 8,
    "avg": 17,
    "max": 23
  },
  {
    "date": "6/29/2019",
    "min": 15,
    "avg": 31,
    "max": 54
  },
  {
    "date": "6/30/2019",
    "min": 25,
    "avg": 40,
    "max": 60
  },
  {
    "date": "7/1/2019"
  }
]